export type RequirenteHomeMode = 'requirente' | 'admin' | 'none';

export interface RequirenteHomeInput {
  mode: RequirenteHomeMode;
  primaryContextId: number | null;
}

/** Single source of truth for requirente home redirects (F0). */
export function resolveRequirenteHome(input: RequirenteHomeInput): string {
  if (input.mode === 'requirente') {
    return input.primaryContextId != null
      ? `/requirentes/${input.primaryContextId}`
      : '/requirentes';
  }
  if (input.mode === 'admin') {
    return '/requirentes';
  }
  return '/dashboard';
}
